module.exports = __webpack_public_path__ + "static/media/ot_2.e687ec6f.JPG";